import { COLOR, mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { fixedOnTop } from "~/components/blocks/layout/global-navi/common/common-style";
import { GLOBAL_NAVI_HEIGHT } from "~/styles/layout";

export const Skeleton = styled.div`
  ${fixedOnTop};
  width: 100%;
  height: ${GLOBAL_NAVI_HEIGHT.PC}px;
  background-color: ${COLOR.GRAY100.code};

  ${mq.sp} {
    height: ${GLOBAL_NAVI_HEIGHT.SP}px;
  }
`;
